import rightPanelTemplate from '../templates/rightPanel.hbs';
import rightPanelTopTemplate from '../templates/rightPanelTop.hbs';
import $ from 'jquery';

$.fn.sdaRightPanel = function(data) {
    const that = this;
    let content = '';
    const $panelSectionTop = that.find('.panel-section-top');
    const $panelMain = that.find('.panel-main');
    const $panelFooter = that.find('.panel-footer');

    if (that.is('[data-compiled]')) {
        return that;
    } else {
        that.attr('data-compiled', '');
    }

    data = data || {};
    $.extend(data, that.data());

    if ($panelSectionTop.length) {
        data.panelSectionTop = $panelSectionTop.html();
        $panelSectionTop.remove();
    }

    if ($panelFooter.length) {
        data.panelFooter = $panelFooter.html();
        $panelFooter.remove();
    }

    if ($panelMain.length) {
        content = $panelMain.html();
    } else {
        content = that.html();
    }

    if (!that.hasClass('sda-clean-panel')) {
        that.html(rightPanelTemplate(data))
            .find('.panel-main')
            .append(content)
            .bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
                that.hasClass('panel-open') ? true : that.removeClass('right-panel-visible');
            });
    }

    if (that.hasClass('no-back')) {
        that.find('.panel-back').remove();
    } else {
        if (!data.panelSectionTop) {
            that.prepend(rightPanelTopTemplate(data));
        }

        that.on('mouseup.close', '.panel-back', function() {
            that.close();
        });
    }
    that.attachMethod('bindClose', function($el) {
        that.off('close').on('close', function(e) {
            e.stopPropagation();
            $el.close();
        });
    });
    that.on('open', function(e) {
        e.stopPropagation();
        that.addClass('right-panel-visible');
        setTimeout(function() {
            that.addClass('panel-open');
        }, 20);
    });
    that.on('close', function(e) {
        e.stopPropagation();

        if (that.data().panelToClose) {
            $(that.data().panelToClose).close();
        } else {
            that.removeClass('panel-open');
        }
    });

    return that;
};
